import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard, DiscardChangesGuard, LanguageResolver, BaseRouteComponent } from 'tms-lib';

const routes: Routes = [
  {
    path: '',
    component: BaseRouteComponent,
    canActivate: [AuthGuard, DiscardChangesGuard],
    resolve: { language: LanguageResolver },
    children: [
      { path: '', redirectTo: 'Home', pathMatch: 'full' },
      {
        path: 'Home',
        loadChildren: () => import('./dashboard/dashboard-routing.module').then((m) => m.DashboardRoutingModule),
      },
      {
        path: 'Administration',
        loadChildren: () =>
          import('./administration/administration-routing.module').then((m) => m.AdministrationRoutingModule),
      },
      {
        path: 'Analysis',
        loadChildren: () => import('./analysis/analysis-routing.module').then((m) => m.AnalysisRoutingModule),
      },
      {
        path: 'Documents',
        loadChildren: () => import('./documents/documents-routing.module').then((m) => m.DocumentsRoutingModule),
      },
      {
        path: 'Fabrics',
        loadChildren: () => import('./fabric/fabric-routing.module').then((m) => m.FabricRoutingModule),
      },
      {
        path: 'Manufacturing',
        loadChildren: () =>
          import('./manufacturing/manufacturing-routing.module').then((m) => m.ManufacturingRoutingModule),
      },
      {
        path: 'Production',
        loadChildren: () => import('./production/production-routing.module').then((m) => m.ProductionRoutingModule),
      },
      {
        path: 'Purchasing',
        loadChildren: () => import('./purchasing/purchasing-routing.module').then((m) => m.PurchasingRoutingModule),
      },
      {
        path: 'Reporting',
        loadChildren: () => import('./reporting/reporting-routing.module').then((m) => m.ReportingRoutingModule),
      },
      {
        path: 'Sales',
        loadChildren: () => import('./sales/sales-routing.module').then((m) => m.SalesRoutingModule),
      },
      {
        path: 'Settings',
        loadChildren: () => import('./settings/settings-routing.module').then((m) => m.SettingsRoutingModule),
      },
      {
        path: 'Stock',
        loadChildren: () => import('./stock/stock-routing.module').then((m) => m.StockRoutingModule),
      },
      {
        path: 'UserAdmin',
        loadChildren: () =>
          import('../../../tms-lib/src/lib/user-admin/user-admin-routing.module').then((m) => m.UserAdminRoutingModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
